export const queryTieredBonusesByCompanyIdIndex = `
  query QueryTieredBonusesByCompanyIdIndex($companyId: ID!, $first: Int, $after: String) {
    queryTieredBonusesByCompanyIdIndex(companyId: $companyId, first: $first, after: $after) {
      nextToken
      items {
        id
        archived
        name
        tiers
        companyId
      }
    }
  }
`;